import { render } from "./DeleteFromBlackList.vue?vue&type=template&id=cbf40c9a"
import script from "./DeleteFromBlackList.vue?vue&type=script&lang=js"
export * from "./DeleteFromBlackList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__